import React, { createContext, useContext, useState, useCallback } from "react";

/**
 * ActivityContext: globaler "Hintergrund läuft"-Status
 *  - track(label): startet einen Job, gibt eine Function zurück, die ihn beendet
 *  - startedJobs: Liste aller laufenden Jobs (für Anzeige)
 *
 * Verwendung:
 *   const { track } = useActivity();
 *   const stop = track("KI analysiert Gutachten");
 *   try { ... } finally { stop(); }
 */
const ActivityContext = createContext(null);

let _id = 0;

export function ActivityProvider({ children }) {
  const [jobs, setJobs] = useState([]);

  const track = useCallback((label) => {
    const id = ++_id;
    setJobs(prev => [...prev, { id, label, startedAt: Date.now() }]);
    return () => {
      setJobs(prev => prev.filter(j => j.id !== id));
    };
  }, []);

  return (
    <ActivityContext.Provider value={{ jobs, track }}>
      {children}
    </ActivityContext.Provider>
  );
}

export function useActivity() {
  const ctx = useContext(ActivityContext);
  if (!ctx) {
    // Fallback no-op (falls Provider fehlt)
    return { jobs: [], track: () => () => {} };
  }
  return ctx;
}
